import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './FollowSteps.module.sass'
import Icon from '../Icon'
import Loader from '../Loader'
import LoaderCircle from '../LoaderCircle'
import { get } from '../../adapters/api'
import { getContracts } from '../../adapters/eth'
import { Web3Context } from '../../contexts/Web3Context'

const FollowSteps = ({ className, instructions, parentCallback }) => {

  const [isApproved, setIsApproved] = useState(false)
  const [isPutted, setPutted] = useState(false)
  const [processApproving, setProcessApproving] = useState(false)
  const [processSell, setProcessSell] = useState(false)
  const [somethingWrong, setSomethingWrong] = useState('')
  const [token, setToken] = useState(false)
  const [contracts, setContracts] = useState()

  const { web3, defaultAccount } = useContext(Web3Context)

  useEffect(() => {
    (async () => {
      const contr = await getContracts(web3)
      setContracts(contr)
    })()
  }, [web3])

  const makeApprove = async (event) => {
    event.preventDefault()

    setProcessApproving(true)

    try {
      const nft = await get('token/item/' + instructions.slug)
      if (!nft.data || +nft.data?.token_id < 0) {
        setSomethingWrong('Token not found')
        return false
      }
      setToken(nft.data)

      const tokenId = nft.data.token_id
      /// Check is approved
      const approved = await contracts.Nft.methods.getApproved(tokenId).call()
      console.log('=== approved for tokenId ===', approved)

      // Approve MP if not approved
      if (approved.toLowerCase() !== contracts.Marketplace.options.address.toLowerCase()) {
        contracts.Nft.methods.approve(contracts.Marketplace.options.address, tokenId).send({ from: defaultAccount }).once('receipt', receipt => {
          console.log('=== approve MP for tokenId ===', receipt)
          setProcessApproving(false)
          setIsApproved(true)
        })
          .on('error', error => {
            setProcessApproving(false)
            setIsApproved(false)
          })
      } else {
        setIsApproved(true)
        setProcessApproving(false)
      }
    } catch (er) {
      setSomethingWrong('Failed to approve Marketplace to sell token.')
      console.error(er)
    }
  }

  const putOnSale = async (event) => {
    event.preventDefault()
    setProcessSell(true)

    try {
      if (!token || +token?.token_id < 0) {
        setSomethingWrong('Token not found')
        return false
      }

      return contracts.Marketplace.methods.sell(contracts.Nft.options.address, token.token_id, instructions.price).send({ from: defaultAccount }).once('receipt', receipt => {
        console.log('=== response of openTrade ===', receipt)
        setProcessSell(false)
        setPutted(true)
      }).on('error', error => {
        setProcessSell(false)
        setPutted(false)
      })
    } catch (er) {
      setSomethingWrong('Failed to put on sale token on Marketplace.')
      console.error(er)
    }
  }

  const tryAgain = () => {
    if (typeof parentCallback === 'function') {
      parentCallback(true)
    }
  }

  const closeIt = () => {
    if (!instructions.readyUrl) {
      window.location.href = '/profile'
    } else if (instructions.readyUrl === 'reload') {
      window.location.reload()
    } else {
      window.location.href = instructions.readyUrl
    }
  }

  return (
    <div className={cn(className, styles.steps)}>
      <div className={cn('h4', styles.title)}>Follow steps</div>
      <div className={styles.list}>
        <div className={cn(styles.item, styles.done)}>
          <div className={styles.head}>
            <div className={styles.icon}>
              <Icon name="upload-file" size="24"/>
            </div>
            <div className={styles.details}>
              <div className={styles.info}>Upload files & Mint token</div>
              <div className={styles.text}>Token published successfully</div>
            </div>
          </div>
          <button className={cn('button done', styles.button)}>Done</button>
        </div>
        {(!somethingWrong || (somethingWrong && isApproved)) &&
          <div className={cn(styles.item, { [styles.done]: isApproved })}>
            <div className={styles.head}>
              <div className={styles.icon}>
                {processApproving ?
                  <LoaderCircle className={styles.loader}/> :
                  <Icon name="pencil" size="24"/>
                }
              </div>
              <div className={styles.details}>
                <div className={styles.info}>Approve sell operation</div>
                <div className={styles.text}>
                  {!isApproved ? 'Approve sell token operation using your wallet' : 'Sell approved successfully'}
                </div>
              </div>
            </div>
            <button
              className={cn('button', styles.button, { ['loading']: processApproving }, { ['done']: isApproved })}
              onClick={makeApprove}>
              {!isApproved ? (processApproving ?
                <Loader className={styles.loader} color="white"/> : 'Approve') : 'Done'}
            </button>
          </div>
        }
        {(!somethingWrong || (somethingWrong && isPutted)) &&
          <div className={cn(styles.item, { [styles.done]: isPutted })}>
            <div className={styles.head}>
              <div className={styles.icon}>
                {processSell ?
                  <LoaderCircle className={styles.loader}/> :
                  <Icon name="pencil" size="24"/>
                }
              </div>
              <div className={styles.details}>
                <div className={styles.info}>Put on sell</div>
                <div className={styles.text}>
                  Put token on sell using your wallet
                </div>
              </div>
            </div>
            <button
              className={cn('button', styles.button, { ['disabled']: !isApproved }, { ['loading']: processSell }, { ['done']: isPutted })}
              onClick={putOnSale}>
              {!isPutted ? (processSell ?
                <Loader className={styles.loader} color="white"/> : 'Put On Sell') : 'Done'}
            </button>
          </div>
        }
        {somethingWrong &&
          <div className={cn(styles.item, styles.error)}>
            <div className={styles.head}>
              <div className={styles.icon}>
                <Icon name="pencil" size="24"/>
              </div>
              <div className={styles.details}>
                <div className={styles.info}>Something gone wrong</div>
                <div className={styles.error}>{somethingWrong}</div>
                <div className={styles.text}>Please try again</div>
              </div>
            </div>
            <a href={'/profile'} className={cn('button error', styles.button)} onClick={tryAgain}>Try again</a>
          </div>
        }
        {isPutted &&
          <div className={cn(styles.item, styles.done)}>
            <div className={styles.head}>
              <div className={styles.icon}>
                <Icon name="bag" size="24"/>
              </div>
              <div className={styles.details}>
                <div className={styles.info}>All is done!</div>
                <div className={styles.text}>
                  You successfully publish your token and put them to marketplace
                </div>
              </div>
            </div>
            <button className={cn('button', styles.button)} onClick={closeIt}>Close</button>
          </div>
        }
      </div>
    </div>
  )
}

export default FollowSteps
